
(function () {
  const STORAGE_KEY = 'pc_makeModel_v1';
  const ROOT = '/';
  const FALLBACK_COLLECTIONS = ROOT + 'collections';

  function safeParse(raw) {
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function toHandle(modelName) {
    return String(modelName || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function openSelect(selectEl) {
    if (!selectEl) return;
    try {
      if (typeof selectEl.showPicker === 'function') {
        selectEl.showPicker();
      } else {
        selectEl.focus();
        selectEl.click();
      }
    } catch (e) {
      try { selectEl.focus(); } catch (_) { }
    }
  }

  function init() {
    const mount = document.getElementById('load_storage_dropdown');
    if (!mount) return;

    const vs = mount.querySelector('.pc-vs');
    const toggleBtn = document.getElementById('pc-vs-toggle');
    const toggleText = document.getElementById('pc-vs-toggle-text');
    const makeEl = document.getElementById('pc-vs-make');
    const modelEl = document.getElementById('pc-vs-model');

    if (!vs || !toggleBtn || !toggleText || !makeEl || !modelEl) return;

    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return;

    const payload = safeParse(raw);
    const data = payload && payload.data ? payload.data : null;
    if (!Array.isArray(data) || data.length === 0) return;

    mount.style.display = 'block';

    const makes = data.map(x => x.make).filter(Boolean).sort((a, b) => a.localeCompare(b));
    makes.forEach(m => {
      const opt = document.createElement('option');
      opt.value = m;
      opt.textContent = m;
      makeEl.appendChild(opt);
    });

    function resetSelections() {
      makeEl.value = '';
      modelEl.innerHTML = '<option value="">Select model</option>';
      modelEl.disabled = true;
    }

    function hardResetToInitial() {
      vs.classList.remove('is-loading');
      vs.classList.remove('is-open');
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleText.textContent = 'See All Compatible Vehicles';
      resetSelections();
    }

    function setOpen(open) {
      if (open) {
        vs.classList.add('is-open');
        toggleBtn.setAttribute('aria-expanded', 'true');
        toggleText.textContent = 'Hide';
        setTimeout(() => openSelect(makeEl), 160);
      } else {
        hardResetToInitial();
      }
    }

    toggleBtn.addEventListener('click', function () {
      const isOpen = vs.classList.contains('is-open');
      setOpen(!isOpen);
    });

    hardResetToInitial();

    makeEl.addEventListener('change', function () {
      const selectedMake = makeEl.value;
      modelEl.innerHTML = '<option value="">Select model</option>';

      const found = data.find(x => x.make === selectedMake);
      if (!found || !Array.isArray(found.models) || found.models.length === 0) {
        modelEl.disabled = true;
        return;
      }

      const models = [...found.models].filter(Boolean).sort((a, b) => a.localeCompare(b));
      models.forEach(modelName => {
        const opt = document.createElement('option');
        opt.value = modelName;
        opt.textContent = modelName;
        modelEl.appendChild(opt);
      });

      modelEl.disabled = false;
      setTimeout(() => openSelect(modelEl), 120);
    });

    modelEl.addEventListener('change', function () {
      const modelName = modelEl.value;
      if (!modelName) return;

      const handle = toHandle(modelName);
      if (!handle) return;

      const target = ROOT + 'products/' + handle;

      vs.classList.add('is-loading');

      fetch(target, { method: 'GET', credentials: 'same-origin' })
        .then(res => {
          if (res && res.ok) {
            window.location.href = target;
          } else {
            window.location.href = FALLBACK_COLLECTIONS;
          }
        })
        .catch(() => {
          window.location.href = FALLBACK_COLLECTIONS;
        });
    });

    window.addEventListener('pageshow', function (e) {
      if (e && e.persisted) hardResetToInitial();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        vs.classList.remove('is-loading');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
